import React from 'react'
import { ReactComponent as ZocksLogo } from '../../../assets/ZocksLogo.svg'
import { Button } from '../../../components/Button/Button'
import { CrossClientClauses } from '../Clauses/CrossClientClauses'
import { CrossClientSources } from './Sources/CrossClientSources'
import { CrossClientQueryDataSource, CrossClientQueryAtomicClause, CrossClientQueryLogicalQuestionNNFDecomposition } from '../../../models/CrossClient'

interface CrossClientQueryDecompositionProps {
  atomicClauses: CrossClientQueryAtomicClause[]
  nnfDecomposition?: CrossClientQueryLogicalQuestionNNFDecomposition
  sources: CrossClientQueryDataSource[]
  onSourcesChange: (sources: CrossClientQueryDataSource[]) => void
  onRestart: () => void
  onConfirm: () => void
  isLoading: boolean
}

export const CrossClientQueryDecomposition = ({
  atomicClauses,
  nnfDecomposition,
  sources,
  onSourcesChange,
  onRestart,
  onConfirm,
  isLoading,
}: CrossClientQueryDecompositionProps) => {
  const numberOfClauses = atomicClauses.length

  return (
    <div className='d-flex flex-column'>
      <div className='d-flex zocks-gap-0.75 align-items-start'>
        <div className='d-flex align-items-center justify-content-center bg-black zocks-border-0.25 cross-client-loader-logo'>
          <ZocksLogo width={12} height={12} />
        </div>
        <div className='d-flex flex-column gap-3 align-items-start'>
          <div className='paragraph-medium'>
            I'll check all clients against {numberOfClauses === 1 ? 'this criterion' : `these ${numberOfClauses} criteria`} and combine them to match your
            question:
          </div>
          <CrossClientClauses atomicClauses={atomicClauses} nnfDecomposition={nnfDecomposition} />
          <CrossClientSources sources={sources} onChange={onSourcesChange} />
          <div className='paragraph-medium'>Ready to run this query?</div>
        </div>
      </div>
      <div className='d-flex gap-2 align-items-center justify-content-end'>
        <Button variant='header' className='button-medium' onClick={onRestart} disabled={isLoading}>
          Ask another question
        </Button>
        <Button variant='primary' className='button-medium' onClick={onConfirm} loading={isLoading}>
          Looks good
        </Button>
      </div>
    </div>
  )
}
